import {
  CASE_UPDATE_USER_PHONE_NUMBER_BEGIN,
  CASE_UPDATE_USER_PHONE_NUMBER_SUCCESS,
  CASE_UPDATE_USER_PHONE_NUMBER_FAILURE,
  CASE_UPDATE_USER_PHONE_NUMBER_DISMISS_FEEDBACK,
} from './constants';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';

export const updateUserPhoneNumber = createPromiseAction(CASE_UPDATE_USER_PHONE_NUMBER_BEGIN);

export function dismissUpdateUserPhoneNumberFeedback() {
  return {
    type: CASE_UPDATE_USER_PHONE_NUMBER_DISMISS_FEEDBACK,
  };
}

export function* doUpdateUserPhoneNumber(action) {
  const { currentCaseId, userId, phoneNumber } = action.payload;
  let res = yield call(api.put, `/cases/${currentCaseId}/users/${userId}/phone`, {
    mobilePhone: phoneNumber,
  });
  if (res && res.error) {
    yield put({
      type: CASE_UPDATE_USER_PHONE_NUMBER_FAILURE,
      feedback: {
        message: 'feedback.updatePhoneNumberFailure',
        error: res.error,
        retryAction: action,
      },
    });
    return yield call(rejectPromiseAction, action, res.error);
  }

  yield put({
    type: CASE_UPDATE_USER_PHONE_NUMBER_SUCCESS,
    data: res,
  });
  yield call(resolvePromiseAction, action, res);
}

export function* watchUpdateUserPhoneNumber() {
  yield takeEvery(updateUserPhoneNumber, doUpdateUserPhoneNumber);
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_UPDATE_USER_PHONE_NUMBER_BEGIN + '.TRIGGER':
      // Just after a request is sent
      return {
        ...state,
        updateUserPhoneNumberPending: true,
        updateUserPhoneNumberFeedback: null,
      };

    case CASE_UPDATE_USER_PHONE_NUMBER_SUCCESS:
      // The request is successful
      return {
        ...state,
        updateUserPhoneNumberPending: false,
        updateUserPhoneNumberFeedback: {
          type: 'success',
          message: 'feedback.updatePhoneNumberSuccess',
        },
      };

    case CASE_UPDATE_USER_PHONE_NUMBER_FAILURE:
      // The request failed
      return {
        ...state,
        updateUserPhoneNumberPending: false,
        updateUserPhoneNumberFeedback: action.feedback,
      };

    case CASE_UPDATE_USER_PHONE_NUMBER_DISMISS_FEEDBACK:
      // Dismiss the feedback
      return {
        ...state,
        updateUserPhoneNumberFeedback: null,
      };

    default:
      return state;
  }
}
